"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
const TabsSet_vue_1 = __importDefault(require("@becrop/components/Toolkit/Heatmap2/vue/UI/TabsSet.vue"));
const Tab_vue_1 = __importDefault(require("@becrop/components/Toolkit/Heatmap2/vue/UI/Tab.vue"));
const AlchemyRecipe_vue_1 = __importDefault(require("@becrop/components/Toolkit/Heatmap2/vue/UI/Modals/AlchemyRecipe.vue"));
const lucide_vue_next_1 = require("lucide-vue-next");
const Alchemy_1 = __importDefault(require("@becrop/components/Toolkit/Heatmap2/models/Alchemy"));
const AlchemyGroup_1 = __importDefault(require("@becrop/components/Toolkit/Heatmap2/models/AlchemyGroup"));
let AlchemyModal = class AlchemyModal extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.samples = [];
        this.option = 'avg';
        this.groupByOptions = [];
        this.groupBy = null;
        this.showModal = this.triggerModal;
    }
    onChangetriggerModal() {
        this.showModal = this.triggerModal;
        if (this.triggerModal) {
            this.onOpen();
        }
        else {
            this.closeModal();
        }
    }
    closeModal() {
        this.$emit('onalchemymodalclose');
    }
    onOpen() {
        this.option = 'avg';
        this.samples = this.heatmap.librarySamples.getNewSelectedSamples();
        this.groupByOptions = [
            AlchemyGroup_1.default.newCore('parcel', 'parcel_name'),
            //AlchemyGroup.newCore('plant_year', 'plant_year'),
            // TODO
            /*
            Filter.newList('soil_type', 'soil_type_id', soil_type_label_fn),
            Filter.newNumber('plant_year', 'plant_year'),
            Filter.newDate('coll_date', 'date'),
            Filter.newBoolean('org_practises', 'org_practises'),
            Filter.newBoolean('art_irrigation', 'art_irrigation'),
            Filter.newBoolean('bio_methods', 'bio_methods'),
            Filter.newNumber('density', 'density'),
            Filter.newList('variety', 'variety'),
            */
        ];
        if (this.heatmap.csv) {
            this.heatmap.csv.fields.forEach(field => {
                if (!field.selected)
                    return;
                const option = AlchemyGroup_1.default.newFromCSV(field);
                this.groupByOptions.push(option);
            });
        }
        this.groupByOptions.forEach(g => g.init(this.samples));
        for (const group of this.groupByOptions) {
            if (group.enabled) {
                this.groupBy = group;
                break;
            }
        }
    }
    createAlchemy() {
        if (!this.groupBy) {
            return;
        }
        // Create the Alchemy samples
        const alchemys = Alchemy_1.default.create(this.samples, this.option, this.groupBy);
        // Add the new samples into the Heatmap
        this.heatmap.addSelection(alchemys);
        // Mark the used samples as disabled in the library
        this.heatmap.librarySamples.markDisabled();
        // Close this modal
        this.closeModal();
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)()
], AlchemyModal.prototype, "triggerModal", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)()
], AlchemyModal.prototype, "heatmap", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('triggerModal')
], AlchemyModal.prototype, "onChangetriggerModal", null);
AlchemyModal = __decorate([
    (0, vue_property_decorator_1.Options)({
        components: {
            TabsSet: TabsSet_vue_1.default,
            Tab: Tab_vue_1.default,
            AlchemyRecipe: AlchemyRecipe_vue_1.default,
            GitMerge: lucide_vue_next_1.GitMerge,
            User: lucide_vue_next_1.User
        }
    })
], AlchemyModal);
exports.default = AlchemyModal;
